import { AppState } from "../index";

export const getAppConfigsState = ({ appConfigs }: AppState) => appConfigs;
